export default __webpack_public_path__ + "static/media/ham-and-cheese.f7de8a66.png";